import DelaunayAlgorithm from './DelaunayAlgorithm';
export default {

    scene: {

        background: null

    },

    camera: {

        fov: 60,
        near: 0.1,
        far: 100,

        position: {

            x: 0,
            y: 0,
            z: 12

        }

    },

    points: {

        count: 220,

        width: 18,
        height: 10,
        depth: 8,

        speed: 0.01,

        color: 0x38bdf8,

        size: 10.0,

        opacity: 0.95

    },

    edges: {

        color: 0x38bdf8,

        opacity: 0.18,

        maxDistance: 1.25,

        maxEdges: 50000

    },

    mouse: {

        enabled: true,

        strengthX: 1.2,

        strengthY: 0.8,

        smoothing: 0.04

    }

};
